<template>
  <div class="grid-view">
    <div class="main-content">
      <div class="section">
        <el-form
          label-width="50px"
          label-position="right"
          inline
          style="height:100%"
        >
          <el-form-item :label="$t('Menu.Search')">
            <cargo-advance-select
              ref="tenantSel"
              :select-type="selectTypeNames.TENANT"
              :cache="false"
              filterable
              :custom-label="companyLabel"
              :callback-params="{key:'relateTenantId'}"
              callback-method-type="value"
              :default-value="String(txtSearch)||''"
              style="width:200px"
              @parentCallBack="tenantIdChangeHandler"
            />
          </el-form-item>
          <el-form-item>
            <el-button type="primary" style="margin-left: 5px" @click="searchHandler">{{ $t('Menu.Search') }}</el-button>
            <el-button type="danger" style="margin-left: 5px" @click="removeHandler">{{ $t('Menu.delete') }}</el-button>
          </el-form-item>
        </el-form>
      </div>
      <div class="section grid-wrapper">
        <cargo-ag-grid
          :grid-options="gridOptions"
          :column-defs="columnDefs"
          :row-data="rowData"
          @gridReady="params=>{gridApi=params.api}"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { getLoading } from '@/utils/utilBaseElement'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import SysMenuWindow from '@/views/cargo/v0/SystemMaintenance/components/sysMenu/SysMenuWindow'
import SysMenuByAddTenantWindow from '@/views/cargo/v0/SystemMaintenance/components/sysMenu/SysMenuByAddTenantWindow'
import * as sysMenuApi from '@/api/menu'
import pinyin from 'js-pinyin'
import { DocumentManage } from '@/utils/commonUtil'

export default {
  name: 'SysMenuView',
  components: { cargoAdvanceSelect, SysMenuWindow, SysMenuByAddTenantWindow },
  data() {
    return {
      isEdit: false,
      txtSearch: '',
      tenantUuid: '',
      documentManage: new DocumentManage(),
      selectTypeNames: TYPE_NAMES,
      gridApi: null,
      gridOptions: {
        rowSelection: 'multiple',
        suppressCellSelection: true,
        treeData: true,
        groupDefaultExpanded: 0,
        getDataPath: data => {
          return data.path.split(',')
        },
        autoGroupColumnDef: {
          headerName: this.$t('Menu.ChineseName'),
          colId: 'chineseLabel',
          field: 'chineseLabel',
          width: 240,
          headerCheckboxSelection: true,
          cellRendererParams: {
            suppressCount: true,
            suppressDoubleClickExpand: true,
            checkbox: params => {
              return true
            },
            innerRenderer: params => {
              return params.value
            }
          }
        },
        context: {
          componentParent: this
        }
      },
      columnDefs: [
        {
          headerName: this.$t('Menu.EnglishName'),
          field: 'englishLabel',
          width: 150
        },
        {
          headerName: this.$t('Menu.Coding'),
          field: 'code',
          width: 150
        },
        {
          headerName: this.$t('Menu.Icon'),
          field: 'icon',
          width: 150
        },
        {
          headerName: this.$t('Menu.Node'),
          field: 'menuId',
          width: 150
        },
        {
          headerName: this.$t('Menu.ParentNode'),
          field: 'parentId',
          width: 150
        },
        {
          headerName: this.$t('Menu.Order'),
          field: 'orderIndex',
          width: 150,
          sort: 'asc'
        },
        {
          headerName: this.$t('Menu.ModuleFile'),
          field: 'actions',
          width: 150
        }
      ],
      rowData: [],
      sourceData: []
    }
  },
  async created() {
  },
  methods: {
    companyLabel(data) {
      if (data) {
        return '[' + data.id + ']' + data.name
      }
      return ''
    },
    tenantIdChangeHandler(item) {
      this.txtSearch = item.value
      if (this.txtSearch) {
        const tenant = this.$refs.tenantSel.options.find(el => el.id === this.txtSearch)
        if (tenant) {
          this.tenantUuid = tenant.uuid
        }
      }
      this.searchHandler()
    },
    searchHandler() {
      if (!this.txtSearch) {
        return
      }
      sysMenuApi.queryTenantMenuList(this.tenantUuid).then(resp => {
        let rowData = resp.data
        this.addTreePath(rowData)
        rowData = rowData.filter(row => !row.path.includes('undefined'))
        this.sourceData = rowData
        this.rowData = rowData
      })
    },
    removeHandler() {
      const items = this.gridOptions.api.getSelectedRows()
      if (this.txtSearch == null) {
        this.$message.warning(this.$t('Menu.PleaseSelectTheCustomer'))
        return
      }
      if (items.length === 0) {
        this.$message.warning(this.$t('Menu.PleaseSelectTheMenu'))
        return
      }
      const menuKeys = []
      for (const m of items) {
        menuKeys.push(m.uuid)
      }
      const params = {}
      params.menuKeys = menuKeys
      params.tenantKey = this.tenantUuid
      const loading = getLoading()
      sysMenuApi.removeTenantMenus(params).then(resp => {
        this.$message.success(this.$t('Menu.SuccessfullyDeleted'))
        this.searchHandler()
      }).finally(() => loading.close())
    },
    menusFilter(item) {
      const inputValue = this.txtSearch.trim()
      if (item.chineseLabel) {
        if (item.chineseLabel.toLowerCase().indexOf(inputValue) > -1) { return true }
        if (pinyin.getCamelChars(item.chineseLabel).toLowerCase().indexOf(inputValue) > -1) { return true }
      }

      if (item.englishLabel && item.englishLabel.toLowerCase().indexOf(inputValue) > -1) { return true }

      if (item.code && item.code.toLowerCase().indexOf(inputValue) > -1) { return true }

      if (item.actions && item.actions.toLowerCase().indexOf(inputValue) > -1) { return true }
      return false
    },
    // 添加树形路径
    addTreePath(menus, menu) {
      const map = new Map()
      menus.forEach(menu => map.set(menu.menuId, menu.uuid))
      // menu有值时，为新增/编辑后的额外处理start
      if (menu) {
        // 已有数据 编辑的
        if (map.has(menu.menuId)) {
          const index = menus.findIndex(m => m.menuId === menu.menuId)
          menus[index] = menu
        } else {
          // 新增的
          menus.push(menu)
        }
      }
      // menu有值时的处理end
      menus.forEach(menu => {
        if (!menu.parentId) {
          menu.path = menu.uuid
        } else {
          menu.path = map.get(menu.parentId) + ',' + menu.uuid
        }
      })
    }
  }
}
</script>

<style scoped>

</style>
